export const WORKSPACE_AGENT_PANEL_VIEW_TRANSITION_S = 0.22;

/** Incoming view enters from the left (e.g. chat, task list when backing out of a drill-down). */
export const workspaceAgentPanelSlideFromLeft = {
  initial: { opacity: 0, x: -12 },
  animate: { opacity: 1, x: 0 },
} as const;

/** Incoming view enters from the right (e.g. tasks, automation runs). */
export const workspaceAgentPanelSlideFromRight = {
  initial: { opacity: 0, x: 12 },
  animate: { opacity: 1, x: 0 },
} as const;

export const workspaceAgentPanelViewTransitionVariants = {
  chat: workspaceAgentPanelSlideFromLeft,
  tasks: workspaceAgentPanelSlideFromRight,
} as const;

export const workspaceAgentPanelMyTasksSubviewTransitionVariants = {
  list: workspaceAgentPanelSlideFromLeft,
  runs: workspaceAgentPanelSlideFromRight,
} as const;

export const getWorkspaceAgentPanelViewMotionTransition = (shouldReduceMotion: boolean) =>
  shouldReduceMotion
    ? { duration: 0 }
    : ({ duration: WORKSPACE_AGENT_PANEL_VIEW_TRANSITION_S, ease: 'easeOut' } as const);
